var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-layout',{staticClass:"layout"},[_c('the-header'),_c('div',{staticClass:"layout__content layout__grow"},[_c('ui-layout-viewport',{staticClass:"layout__menu"},[_c('the-menu')],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }